import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { getCommonClassNameDefault } from '@skatteetaten/ds-core-utils';
import { Icon } from '@skatteetaten/ds-icons';
import './styles.css';


const getTagSizeDefault = ()=>'medium';
const getTagColorDefault = ()=>'ochre';

var styles = {
    "tag": "Tag-module_tag__aDe2B",
    "iconWrapper": "Tag-module_iconWrapper__gcayO",
    "icon": "Tag-module_icon__Sn6D8",
    "tag_ochre": "Tag-module_tag_ochre__lPHtc",
    "tag_burgundy": "Tag-module_tag_burgundy__xwjBL",
    "tag_forest": "Tag-module_tag_forest__7OEy9",
    "tag_graphite": "Tag-module_tag_graphite__Ojm3Y",
    "tag_medium": "Tag-module_tag_medium__sw1g6",
    "tag_small": "Tag-module_tag_small__cHMD0"
};

const Tag = /*#__PURE__*/ forwardRef(({ id, className = getCommonClassNameDefault(), lang, 'data-testid': dataTestId, canBeManuallyFocused, color = getTagColorDefault(), size = getTagSizeDefault(), svgPath, children }, ref)=>{
    const variantClassName = styles[`tag_${color}`];
    const sizeClassName = styles[`tag_${size}`];
    return /*#__PURE__*/ jsxs("div", {
        ref: ref,
        id: id,
        lang: lang,
        "data-testid": dataTestId,
        className: `${styles.tag} ${variantClassName} ${sizeClassName} ${className}`.trim(),
        tabIndex: canBeManuallyFocused ? -1 : undefined,
        children: [
            svgPath && /*#__PURE__*/ jsx("div", {
                className: styles.iconWrapper,
                "aria-hidden": true,
                children: /*#__PURE__*/ jsx(Icon, {
                    className: styles.icon,
                    svgPath: svgPath
                })
            }),
            children
        ]
    });
});
Tag.displayName = 'Tag';

export { Tag, getTagColorDefault, getTagSizeDefault };
